import { useState, useEffect } from 'react';

// Custom hook to detect if the user is on mobile view
function CheckforMobile() {
  const [mobileView, setMobileView] = useState(window.innerWidth < 599);

  useEffect(() => {
    const handleResize = () => {
      setMobileView(window.innerWidth < 599);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return mobileView;
}

export default CheckforMobile;
